import { cache } from '@/container/apollo-client/cache';

export const removeFromCache = (id: number | number[], typename: string) => {
  try {
    const ids = Array.isArray(id) ? id : [id];
    ids.forEach((singleId) => {
      const normalizedId = cache.identify({ id: singleId, __typename: typename });
      cache.evict({ id: normalizedId });
    });
    cache.gc();
  } catch (error) {
    console.error('Error removing from cache:', error, { id, typename });
  }
};

export function evictAllTypename(fieldNames: string[], args?: Record<string, string | number>) {
  fieldNames.forEach((fieldName) => {
    cache.evict({
      fieldName,
      args,
    });
  });
  cache.gc();
}
